const analytics = require('analytics');

module.exports = function (name) {
  return function (...args) {
    analytics.send(name, ...args);
  }
};


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/analytics-curry.js